import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { CategoryContextProvider } from "./contexts/CategoryContext";
import { LanguageContextProvider } from "./contexts/LanguageCtx";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <LanguageContextProvider>
      <CategoryContextProvider>
        <App />
      </CategoryContextProvider>
    </LanguageContextProvider>
  </React.StrictMode>
);
reportWebVitals();
